import React from "react";
import { withTranslation } from "react-i18next";
import { withRouter } from "../../../providers/withRouter";
import { getAAFF, getAllTecnicos, asignarTecnico, getOnlyAAFF } from "../../../services";
import { toast } from "react-toastify";
import HeaderBackground from "../../../images/banner_administradores.jpg";
import { Grid, CircularProgress } from "@mui/material";
import Add from "../../../icons/add.svg";
import BreadCrumb from "../../../components/navbar/Breadcrumb";
import { te } from "date-fns/locale";

class AsignarTecnico extends React.Component {
  constructor() {
    super();
    this.state = {
      nombre: "",
      aaff: undefined,
      resultados: undefined,
      tecnicos: [],
      loading: true // Bandera para saber si se están cargando los técnicos o el AAFF
    };
  }

  componentDidMount() {
    // Cargar datos del AAFF
    getOnlyAAFF(this.props.params.nif).then((res) => {
      this.setState({ aaff: res });
    });
    // Cargar técnicos
    getAllTecnicos().then((res) => {
      const tecnicos = res
        .map((c) => ({
          id: c.id,
          nif: c.nif,
          nombre: c.nombre,
          apellidos: c.apellidos,
          busqueda: c.nombre + " " + c.apellidos,
        }));
        console.log(tecnicos);
      this.setState({ tecnicos, loading: false });
    });
  }

  buscar = (e) => {
    e.preventDefault();
    const { t } = this.props;
    if (this.state.tecnicos.length === 0) {
      toast.error(t('common:status.dataStillLoading'));
      return;
    }
    const seleccionado = this.state.tecnicos.find((c) => c.id === Number(this.state.nombre));
    this.setState({ resultados: seleccionado ? [seleccionado] : [] });
  };

  render() {
    const { t } = this.props;
    // Consideramos loading mientras el AAFF no se haya cargado o loading sea true
    const isLoading = this.state.aaff === undefined || this.state.loading;

    return (
      <>
        <BreadCrumb
          rutas={[
            { path: "/aaff", label: t('aaff:title') },
            { path: `/aaff/${this.state.aaff ? this.state.aaff.nif : ""}`, label: this.state.aaff ? this.state.aaff.razonSocial : "" }
          ]}
          style={{ margin: "0 10px" }}
        />
        {/* Contenedor con posición relativa para el overlay */}
        <div className="pageContent" style={{ position: "relative" }}>
          <div className="listPage">
            <div className="gridCard">
              <div className="gridHead">{t('aaff:actions.assignTechnicianTitle')}</div>
            </div>
          </div>
          <form className="nuevoAAFFForm" onSubmit={this.buscar}>
            <Grid container spacing={5} style={{ marginTop: 20, marginBottom: 20 }}>
              <Grid item xs={12} sm={4}>
                <select
                  required
                  value={this.state.nombre}
                  onChange={(e) => this.setState({ nombre: e.target.value })}
                  disabled={isLoading}
                >
                  <option value="">{t('common:form.name')}</option>
                  {this.state.tecnicos.map((c) => (
                    <option key={c.id} value={c.id}>
                      {c.nombre} {c.apellidos}
                    </option>
                  ))}
                </select>
              </Grid>
            </Grid>
            <input type="submit" value={t('common:actions.search')} disabled={isLoading} />
          </form>
          <Resultados 
            resultados={this.state.resultados} 
            aaff={this.state.aaff}
            group={this.props.params.idGroup}
            t={t} />
          {/* Overlay del spinner */}
          {isLoading && (
            <div style={{
              position: "absolute",
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              backgroundColor: "rgba(255,255,255,0.7)",
              zIndex: 10
            }}>
              <CircularProgress />
            </div>
          )}
        </div>
      </>
    );
  }
}

class Resultados extends React.Component {
  enviarEmail = (e) => {
    console.log("enviar email");
  };

  asignar = (resultado) => {
    const { t } = this.props;
    asignarTecnico(this.props.aaff.nif, resultado.id, this.props.group)
      .then((res) => {
        toast.success(t('aaff:messages.technicianAssigned'));
        window.location.replace("/aaff");
      })
      .catch((err) => {
        console.log(err);
        toast.error(t('aaff:messages.assignTechnicianError'));
      });
  };

  render() {
    const { t } = this.props;
    if (this.props.resultados === undefined) return null;
    return (
      <div className="tableContainer" style={{ marginTop: 30 }}>
        <table>
          <thead>
            <tr>
              <th>{t('common:technicians.titleSingular')}</th>
              <th>{t('common:form.nif')}</th>
              <th style={{ textAlign: "center" }}>{t('aaff:actions.assign')}</th>
            </tr>
          </thead>
          <tbody>
            {this.props.resultados.length === 0 ? (
              <tr>
                <td colSpan={3} style={{ textAlign: "center" }}>
                  {t('common:status.noMatchingResults')}
                </td>
              </tr>
            ) : (
              this.props.resultados.map((e, i) => (
                <tr key={i}>
                  <td>{e.nombre + " " + e.apellidos}</td>
                  <td>{e.nif}</td>
                  <td style={{ textAlign: "center" }}>
                    <div
                      className="asignarButton"
                      style={{
                        marginLeft: "auto",
                        marginRight: "auto",
                        cursor: "pointer",
                      }}
                      onClick={() => this.asignar(e)}
                    >
                      <img src={Add} alt={t('aaff:actions.assign')} />
                      {t('aaff:actions.assign')}
                    </div>
                  </td>
                </tr>
              ))
            )}
          </tbody>
        </table>
      </div>
    );
  }
}

export default withTranslation(['aaff', 'common'])(withRouter(AsignarTecnico));